import { useMemo, useState } from "react";
import { useLayoutStyles } from "./styles";
import "./styles.css";
import { Header } from "./header";
import { SideNav } from "./sideNav";
import { LayoutProps } from "../";
import { ClaimHelper } from "../../utils/helpers";
import { EnvironmentBar } from "./environmentBar";
import { ISideNavSettings, GetSideNavSettings } from "../../configuration";
import { ILayoutStyles } from "../styles/ILayoutStyles";
import { useLocation } from "react-router-dom";
import { useCommunity } from "../../../context/communityContext";

export const Layout = (props: LayoutProps) => {
    const styles: ILayoutStyles = useLayoutStyles();
    const location = useLocation();
    const userDisplayName: string = ClaimHelper.getDisplayName();
    const isAuthenticated: boolean = ClaimHelper.isAuthenticated();
    const communityContext = useCommunity();
    const orgIdFromClaims = ClaimHelper.getCommunityId?.() ?? null;
    const activeCommunityId = (communityContext.communityId ?? orgIdFromClaims)?.toString() ?? null;
    const sideNavSettings = useMemo(
        () => GetSideNavSettings(isAuthenticated, userDisplayName, props.hasNewNotification, activeCommunityId),
        [isAuthenticated, userDisplayName, props.hasNewNotification, activeCommunityId]
    );

    const [sideNavIsExpanded, setSideNavExpansion] = useState(true);
    const sideNavToggleHandle = () => {
        setSideNavExpansion(!sideNavIsExpanded);
    };

    const hideHeader = useMemo(() => {
        const hide = ["/signin", "/signin-oidc", "/logout", "/silentrenew", "/logout/callback", "/", "/bloomberg", "/privacy", "/support", "/deleteaccount"];
        return hide.includes(location.pathname.toLowerCase());
    }, [location.pathname]);


    return (
        <main className="d-flex flex-column flex-nowrap align-items-stretch w-100" style={styles?.mainContainer}>
            <EnvironmentBar environmentSettings={props.environmentSettings} styles={styles?.environmentBar} />
            <Header
                style={styles}
                userDisplayName={userDisplayName}
                hasNewNotification={props.hasNewNotification}
                handleSideNavToggle={sideNavToggleHandle}
                isAuthenticated={isAuthenticated}
                sideNavSettings={sideNavSettings}
                onLogin={props.onLogin}
                onLogout={props.onLogout}
                hideHeader={hideHeader}
            />
            <div className="d-flex flex-fill flex-nowrap align-items-stretch overflow-y-hidden">
                <SideNav style={styles?.sideNav} userDisplayName={userDisplayName} hasNewNotification={props.hasNewNotification} isExpanded={sideNavIsExpanded} sideNavSettings={sideNavSettings} />
                <div className="d-flex flex-column flex-nowrap align-items-stretch overflow-y-auto" style={styles?.contentContainer} >
                    <div className="flex-fill " style={styles?.page.pageSection}>
                        {props.children}
                    </div>
                </div>
            </div>
        </main>
    );
};